// react-dnd dropzone

import { Card, CardProps } from "@chakra-ui/react";
import { useEffect } from "react";
import { DropTargetMonitor, useDrop } from "react-dnd";
import { Bank, Preset } from "../utils/types";

export enum DraggableType {
    BANK = 'bank',
    PRESET = 'preset',
}

interface Props extends Omit<CardProps, 'onDrop'> {
    onDrop: (item: Bank | Preset, targetIndex: number) => void;
    onIsOverChange?: (isOver: boolean) => void;
    accept: DraggableType[];
    index: number;
}

export const DropZone = ({ accept, onDrop, onIsOverChange, index, maxHeight, minHeight, ...props }: Props) => {
    const [{ isOver }, drop] = useDrop({
        accept,
        drop: (item: Bank | Preset) => onDrop(item, index),
        collect: (monitor: DropTargetMonitor) => ({
            isOver: monitor.isOver(),
            canDrop: monitor.canDrop(),
        }),
    });

    useEffect(() => {
      if (onIsOverChange) {
        onIsOverChange(isOver);
      }
    }, [isOver]);

    return (
        <Card
            ref={drop}
            bg={'grey.200'}
            width='100%'
            minWidth='1rem'
            marginY='0.25rem'
            opacity={isOver ? 0.4 : 0}
            minHeight={isOver ? maxHeight : (minHeight ?? '1rem')}
            alignItems="center"
            border={isOver ? '1px dashed black' : 'none'}
            // expand and collapse gradually
            transition='all 0.2s ease-in-out'
            {...props}
        />
    );
};